const items = [
  "Trust over tactics",
  "Listening first",
  "No judgment",
  "Confidential",
  "LGBTQ+ affirming",
  "Family-centered",
  "Real talk, real progress",
];

export function Marquee() {
  return (
    <section aria-label="Practice values" className="relative border-y border-border/60 bg-sage-soft/40 py-5">
      <div className="overflow-hidden">
        <div className="flex w-max animate-marquee gap-12 whitespace-nowrap text-sage-deep">
          {[...items, ...items].map((t, i) => (
            <span key={i} className="flex items-center gap-12 font-display text-xl italic">
              {t}
              <span aria-hidden className="inline-block h-2 w-2 rotate-45 bg-sage" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
